@if (isLoadingRoles || isSaving) {
    <div class="PGAdmin-Loading">
        <app-pg-loading [isLarge]="true" [isOverlay]="true"></app-pg-loading>
    </div>
}
<div class="PGAdminUsers PGAdminContent">
    <h4 class="m-0 pt-3">Users</h4>
    <div>
        <div class="PGAdmin-Header navbar row">
            <div class="col col-12">
                <div class="input-group">
                    <div class="input-group-text">
                        <i class="fa-regular fa-search"></i>
                    </div>
                    <input class="form-control ng-untouched ng-pristine ng-valid" placeholder="Search..." type="text" [(ngModel)]="search" (change)="onSearchChange()">
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row PGAdmin-Header">
                <div class="col col-1 PGAdminUsers-Col-Text">id</div>
                <div class="col PGAdminUsers-Col-Text">name</div>
                <div class="col PGAdminUsers-Col-Text">surname</div>
                <div class="col PGAdminUsers-Col-Text">c.fiscale</div>
                <div class="col PGAdminUsers-Col-Text">password</div>
                <div class="col PGAdminUsers-Col-Text">email</div>
                <div class="col PGAdminUsers-Col-Text">telephone</div>
                <div class="col PGAdminUsers-Col-Buttons"></div>
                <div class="col-2 border-start">customer care</div>
            </div>
        </div>
        <div class="container-fluid PGAdminUsers-Content">
            @for (user of dataRows; track user) {
                <div class="row">
                    <div class="col col-1 PGAdminUsers-Col-Text">{{user.id}}</div>
                    <div class="col">
                        <input class="form-control" [(ngModel)]="user.name" [readonly]="!actions.edit || isElementProtected(user)"/>
                    </div>
                    <div class="col">
                        <input class="form-control" [(ngModel)]="user.surname" [readonly]="!actions.edit || isElementProtected(user)"/>
                    </div>
                    <div class="col">
                        <input class="form-control" [(ngModel)]="user.codice_fiscale" [readonly]="!actions.edit || isElementProtected(user)"/>
                    </div>
                    <div class="col">
                        <input class="form-control" [(ngModel)]="user.password" [readonly]="!actions.edit || isElementProtected(user)"/>
                    </div>
                    <div class="col">
                        <input class="form-control" [(ngModel)]="user.email" [readonly]="!actions.edit || isElementProtected(user)"/>
                    </div>
                    <div class="col">
                        <input class="form-control" [(ngModel)]="user.telephone" [readonly]="!actions.edit || isElementProtected(user)"/>
                    </div>
                    <div class="col PGAdminUsers-Col-Buttons">
                        <button class="btn btn-sm btn-primary me-1" (click)="saveUser(user)" [disabled]="!actions.edit || isElementProtected(user)">
                            <i class="fa-regular fa-save"></i>
                        </button>
                        <app-pg-confirm-action (confirmed)="deleteUser(user)" [disabled]="!actions.delete || isElementProtected(user)">
                            <button class="btn btn-sm btn-danger" [disabled]="!actions.delete || isElementProtected(user)">
                                <i class="fa-regular fa-trash"></i>
                            </button>
                        </app-pg-confirm-action>
                    </div>
                    <div class="col-2 border-start">
                        <app-pg-customer-care-settings [userId]="user.id" [userProfile]="user.related_profile" [keepOpen]="true"></app-pg-customer-care-settings>
                    </div>
                </div>
                <div class="row border-bottom">
                    <div class="col col-1 PGAdminUsers-Col-Text">
                        <b>GROUPS</b>
                    </div>
                    <div class="col">
                        <app-pg-resource-association resourceId="Group" relatedResource="User" [relatedElement]="user.id" [relationConfig]="groupUserRelationConfig" [resourceSemantic]="idLabelSemantic" [resourceData]="user.related_group" [readonly]="isElementProtected(user)"></app-pg-resource-association>
                    </div>
                </div>
            }

            <app-pg-view-more [hidden]="isLoadingData || isAtEnd" (viewMore)="loadData()"></app-pg-view-more>
            @if (isLoadingData) {
                <app-pg-loading></app-pg-loading>
            }
        </div>
        <div class="container-fluid">
            <div class="row PGAdmin-Footer">
                <div class="col col-1"></div>
                <div class="col">
                    <input class="form-control" [(ngModel)]="createUserData.name" [readonly]="!actions.create"/>
                </div>
                <div class="col">
                    <input class="form-control" [(ngModel)]="createUserData.surname" [readonly]="!actions.create"/>
                </div>
                <div class="col">
                    <input class="form-control" [(ngModel)]="createUserData.codice_fiscale" [readonly]="!actions.create"/>
                </div>
                <div class="col">
                    <input class="form-control" [(ngModel)]="createUserData.password" [readonly]="!actions.create"/>
                </div>
                <div class="col">
                    <input class="form-control" [(ngModel)]="createUserData.email" [readonly]="!actions.create"/>
                </div>
                <div class="col">
                    <input class="form-control" [(ngModel)]="createUserData.telephone" [readonly]="!actions.create"/>
                </div>
                <div class="col PGAdminUsers-Col-Buttons">
                    <button class="btn btn-sm btn-primary" [disabled]="!actions.create" (click)="createUser()">
                        <i class="fa-regular fa-plus"></i>
                    </button>
                </div>
                <div class="col-2"></div>
            </div>
        </div>
    </div>
</div>